import { BaseService } from 'core/common/services';
import { UserSettings } from '../../entities';

export class SettingsService extends BaseService {
  async updateUserSettings(params: Partial<UserSettings> = {}): Promise<void> {
    await this.httpClient.put(`/user/settings`, {
      data: params,
    });
  }
}
